import Vue from 'vue'
import Router from 'vue-router'


const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
}

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/404',
            component: () => import('@/views/404')
        },
        {
            path: '/',
            name: 'Menu',
            component: () => import('@/views/Index'),
            children: [
                {
                    path: 'userManage',
                    component: () => import('@/components/menus/UserManage')
                },
                {
                    path: 'imagesManage',
                    component: () => import('@/components/menus/ImagesManage.vue')
                },
                {
                    path: 'wordsManage',
                    component: () => import('@/components/menus/WordsManage.vue')
                },
                {
                    path: 'voicePreviewManage',
                    component: () => import('@/components/menus/VoicePreviewManage.vue')
                },
                {
                    path: 'memoryCircleTagManage',
                    component: () => import('@/components/menus/MemoryCircleTagManage.vue')
                },
                {
                    path: 'memoryCircleTemplateManage',
                    component: () => import('@/components/menus/MemoryCircleTemplateManage.vue')
                },
                {
                    path: 'localModelManage',
                    component: () => import('@/components/menus/LocalModelManage.vue')
                },
                {
                    path: 'onlineModelManage',
                    component: () => import('@/components/menus/OnlineModelManage.vue')
                },
                {
                    path: 'presetsManage',
                    component: () => import('@/components/menus/PresetsManage.vue')
                },
                {
                    path: 'expresPresetsManage',
                    component: () => import('@/components/menus/ExpresPresetsManage.vue')
                },
                {
                    path: 'modelPresetsManage',
                    component: () => import('@/components/menus/ModelPresetsManage.vue')
                },
                {
                    path: 'dictionaryManage',
                    component: () => import('@/components/menus/DictionaryManage.vue')
                },
                {
                    path: 'wechatCardManage',
                    component: () => import('@/components/menus/WechatCardManage.vue')
                },
                {
                    path: 'sensitiveWordManage',
                    component: () => import('@/components/menus/SensitiveWordManage.vue')
                },
                {
                    path: 'wxMpDefaultDeviceManage',
                    component: () => import('@/components/menus/WxMpDefaultDeviceManage.vue')
                },
                {
                    path: 'invitationDeviceManage',
                    component: () => import('@/components/menus/InvitationDeviceManage.vue')
                },
                {
                    path: 'diagnosticReports',
                    component: () => import('@/components/menus/DiagnosticReports.vue')
                },
                {
                    path: 'launcherUpdate',
                    component: () => import('@/components/menus/LauncherUpdateManage.vue')
                },
                {
                    path: 'dashboard',
                    component: () => import('@/components/menus/Dashboard.vue')
                },
                {
                    path: "/",
                    redirect: "userManage"
                }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/Login'),
        },
        {path: '*', redirect: '/404'}
    ],
    mode: "hash"
})
